import { useEffect } from "react";
import AuthCMS from "../../../Layouts/AuthCMS"
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Form, Input, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { createNew, getItem, getList, getStateItem, updateItem } from "../../../Stores/Location/Slice";
import BoxAssociate from "./BoxAssociate";

// Constrant 
const modelField = ['name', 'address', 'city', 'description', 'region']
const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 6,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 14,
        },
    },
};

// CORE COMPONENT
const DetailLocation = ({ }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const data = useSelector(getStateItem);
    const { id } = useParams();
    const [form] = Form.useForm()

    useEffect(() => {
        form.resetFields()
        form.setFieldsValue(data.data)
    }, [data])

    useEffect(() => {
        // Get Detail Location with ID
        dispatch(getItem(id))
    }, [id])

    const tabs = [
        {
            key: 'Detail',
            label: 'Detail Location',
            children: <DetailComponent form={form} data={data}/>,
        },
        {
            key: 'Box Associate',
            label: 'Box Associate',
            children: <BoxAssociate />,
        },
        // {
        //     key: 'Line Associate',
        //     label: 'Line Associate',
        //     children: "",
        // },
    ];

    const onBackEvent = () => {
        navigate(-1)
    }

    const onSaveEvent = () => {
        const dataForm = form.getFieldsValue(true)
        if (id == "create") {
            // Create new
            dispatch(createNew(dataForm)).then(res => {
                if (res.payload.status === 200) {
                    dispatch(getList())
                    navigate(-1)
                }
            })
        } else {
            // Update
            dispatch(updateItem(dataForm)).then(res => {
                if (res.payload.status === 200) {
                    dispatch(getList())
                    navigate(-1)
                }
            })
        }
    }

    return <AuthCMS tabActive={"/location"}>
        <div className="px-6 mt-4 flex gap-4">
            <Button className="self-center" onClick={onBackEvent}>&larr; Back</Button>
            <h1 className="flex-1">{data.isLoading ?
                "Loading.." : 
                (id == "create" ? "Create New" : data.data.name)}<br></br>
                <small>{id}</small>
            </h1>
            <Button className="self-center" type="primary" onClick={onSaveEvent}>&#10003; Save</Button>
        </div>
        <Tabs defaultActiveKey="1" items={tabs} className="p-6 py-4" />
    </AuthCMS>
}

// Child Component
const DetailComponent = ({ form, data }) => {
    return <Card
        style={{
            marginTop: 4,
            maxWidth: 800,
        }}
        type="inner"
        title="Configuration Panel"
        loading={data.isLoading}
    >
        <Form
            form={form}
        >
            {modelField.map((key, index) => {
                return <Form.Item
                    {...formItemLayout}
                    key={index}
                    label={key.toUpperCase()}
                    name={key}
                >
                    <Input />
                </Form.Item>
            })}
        </Form>
    </Card>
}

export default DetailLocation